import { createReducer } from "@reduxjs/toolkit";

import {
  getListFAQCategories,
  getListFAQCategoriesSuccess,
  getListFAQCategoriesFailure,
  getPortionListFAQCategory,
  getPortionListFAQCategorySuccess,
  getPortionListFAQCategoryFailure,
  getFAQCategoryItems,
  getFAQCategoryItemsSuccess,
  getFAQCategoryItemsFailure,
  getPortionFAQCategoryItems,
  getPortionFAQCategoryItemsSuccess,
  getPortionFAQCategoryItemsFailure,
  resetCategoryItems,
} from "./actions";

const initialState = {
  allCategories: [],
  categoriesById: {},
  allItems: [],
  itemsById: {},
  itemsTotalCount: undefined,
  itemsNextOffset: undefined,
  totalCount: undefined,
  nextOffset: undefined,
  isLoading: false,
  error: null,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getListFAQCategories.type, (state, action) => ({
      ...state,
      isLoading: true,
      ...action.payload,
    }))
    .addCase(getListFAQCategoriesSuccess.type, (state, action) => ({
      ...state,
      ...action.payload,
      isLoading: false,
    }))
    .addCase(getListFAQCategoriesFailure.type, (state, action) => ({
      ...state,
      isLoading: false,
      error: action.payload,
    }))
    .addCase(resetCategoryItems.type, () => ({
      ...initialState,
    }))
    .addCase(getPortionListFAQCategory.type, (state, action) => ({
      ...state,
      isLoading: true,
      ...action.payload,
    }))
    .addCase(getPortionListFAQCategorySuccess.type, (state, { payload }) => {
      const { allCategories, categoriesById } = state;
      const {
        allCategories: newCategories,
        categoriesById: newCategoriesById,
        totalCount,
        nextOffset,
      } = payload;

      return {
        ...state,
        allCategories: [...allCategories, ...newCategories],
        categoriesById: { ...categoriesById, ...newCategoriesById },
        totalCount,
        nextOffset,
        error: initialState.error,
        isLoading: false,
      };
    })
    .addCase(getPortionListFAQCategoryFailure.type, (state, action) => ({
      ...state,
      isLoading: false,
      error: action.payload,
    }))
    .addCase(getFAQCategoryItems.type, (state, action) => ({
      ...state,
      isLoading: true,
      allItems: initialState.allItems,
      ...action.payload,
    }))
    .addCase(getFAQCategoryItemsSuccess.type, (state, { payload }) => {
      return {
        ...state,
        ...payload,
        itemsById: { ...state.itemsById, ...payload.itemsById },
        isLoading: false,
      };
    })
    .addCase(getFAQCategoryItemsFailure.type, (state, action) => ({
      ...state,
      isLoading: false,
      error: action.payload,
    }))
    .addCase(getPortionFAQCategoryItems.type, (state, action) => ({
      ...state,
      isLoading: true,
      ...action.payload,
    }))
    .addCase(getPortionFAQCategoryItemsSuccess.type, (state, { payload }) => {
      const { allItems, itemsById } = state;
      const {
        allItems: newItems,
        itemsById: newItemsById,
        itemsTotalCount,
        itemsNextOffset,
      } = payload;

      return {
        ...state,
        allItems: [...allItems, ...newItems],
        itemsById: { ...itemsById, ...newItemsById },
        itemsTotalCount,
        itemsNextOffset,
        error: initialState.error,
        isLoading: false,
      };
    })
    .addCase(getPortionFAQCategoryItemsFailure.type, (state, action) => ({
      ...state,
      isLoading: false,
      error: action.payload,
    }));
});
